// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_PHOTO = "Naozaj chce\u0161 zmaza\u0165 fotku?";
export const CLICK_HERE_TO_ENTER_DESCRIPTION = "Klikni sem a zadaj popis";
export const GO_BACK_TO_ALBUM = "Sp\u00e4\u0165 na album";
export const GO_BACK_TO_AUTOMATIC_MESSAGE = "Sp\u00e4\u0165 na spr\u00e1vu";
export const GO_BACK_TO_GROUP_POST = "Sp\u00e4\u0165 na spr\u00e1vu";
export const GO_BACK_TO_SHORT_MESSAGE = "Sp\u00e4\u0165 na spr\u00e1vu";
export const SAVE_DESCRIPTION = "Ulo\u017e popis";
export const WAS_ADDED_when = "Pridan\u00e9 %(when)s";
